
import React, { useState } from 'react';
import { Challenge } from '../lib/types';
import { Calendar } from 'lucide-react';
import { WinnerCard } from './WinnerCard';

interface PastChallengeCardProps {
  challenge: Challenge;
  isVoted: boolean;
  onVote: (submissionId: string) => void;
}

export function PastChallengeCard({ challenge, isVoted, onVote }: PastChallengeCardProps) {
  const [fadeIn, setFadeIn] = useState(false);

  React.useEffect(() => {
    setTimeout(() => setFadeIn(true), 100); // smooth entrance
  }, [challenge.id]);

  return (
    <div
      className={`bg-bauhaus-offwhite border-2 border-bauhaus-green rounded-lg shadow-sm overflow-hidden transition-all duration-700 ${fadeIn ? "animate-fade-in" : "opacity-0"}`}
    >
      <div className="challenge-gradient text-bauhaus-green p-4">
        <div className="flex items-center mb-2">
          <Calendar className="h-5 w-5 mr-2" />
          <span>{new Date(challenge.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric' })}</span>
        </div>
        <h2 className="text-xl font-semibold">{challenge.selectedPrompt?.text}</h2>
      </div>
      <div className="p-4">
        <WinnerCard
          winner={challenge.winner}
          isVoted={isVoted}
          onVote={onVote}
        />
      </div>
    </div>
  );
}
